const iOSDeviceList = [
  'iPad Simulator',
  'iPhone Simulator',
  'iPod Simulator',
  'iPad',
  'iPhone',
  'iPod',
  'MacIntel',
  'Mac',
]

export const isIOS = () => {
  if (typeof window === 'undefined') {
    return
  }

  return (
    iOSDeviceList.some(device => navigator.userAgent.includes(device)) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  )
}

export const isAndroid = typeof window !== 'undefined' && navigator?.userAgent?.includes('Android')

export const isChrome = () => {
  if (typeof window === 'undefined') {
    return
  }

  return navigator.appVersion.includes('Chrome')
}
